<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ label }}</span>
		<div class="search-option-wrapper__normal" style="width: 300px">
			<el-radio v-model="radio" label="" @change="change">{{ getMessage_('MWCC000753') }}</el-radio>

			<el-radio v-model="radio" v-for="(prcStepGb, index) in prcsStepList" :key="index" :label="prcStepGb.commCd" @change="change">{{
				prcStepGb.commCdName
			}}</el-radio>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/ClamRepay/store/helpers';
export default {
	props: ['label', 'paramKey'],
	data() {
		return {
			radio: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			//console.log('value값은', value);

			this.setSearchParam_({ key: 'prcStepGb', value: value }).then(() => {
				//this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.radio = this.searchParams.prcStepGb;
		}
	},
	created() {
		if (this.searchParams.prcStepGb == null || this.searchParams.prcStepGb == '') this.searchParams.prcStepGb = '';
		this.radio = this.searchParams.prcStepGb;
	}
};
</script>

<style></style>
